import { Form, Formik, useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as list from "src/core/statics/form-data/form-data";
import Select from "./select-component";
import { appRoutesObj } from "src/app.paths";
import i18n from "src/core/configs/i18n";

function QuestionForms() {
  const { t } = useTranslation();
  const [openForm, setOpenForm] = useState(1);
  type InitialValuesType = {
    country: string;
    city: string;
    district: string;
    numberofstudent: string;
    budgetandfees: string;
    edusystem: string;
    providingbuses: string;
    educationevel: string;
    ExtracurricularActivities: string;
    SportsActivities: string;
  };
  const initialValues: InitialValuesType = {
    country: "",
    city: "",
    district: "",
    numberofstudent: "",
    budgetandfees: "",
    edusystem: "",
    providingbuses: "",
    educationevel: "",
    ExtracurricularActivities: "",
    SportsActivities: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {},
  });
  const handleNextAndPreviousForms = (action: string) => {
    switch (action) {
      case "next":
        setOpenForm(openForm + 1);
        break;
      case "prev":
        setOpenForm(openForm - 1);
        break;
    }
  };
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="fixed flex top-0 left-0 inset-y-0 inset-x-0 mx-auto my-auto items-center justify-center bg-white shadow-[rgba(0,_0,_0,_0.30)_10px_10px_200px_-3px] w-[740px] h-[825px] tablet:w-[680px] tablet:h-[765px] mobile:w-[355px] mobile:h-[703px] rounded-[32px] mobile:px-2 mobile:py-10"
    >
      <div className="flex flex-col items-center">
        <Link to={appRoutesObj.getResearchResultsPath()}>
          <div
            className={`text-blue600 text-base mobile:text-sm ${
              i18n.language === "ar"
                ? "mr-[500px] tablet:mr-[400px] mobile:mr-[210px]"
                : "ml-[500px] tablet:ml-[400px] mobile:ml-[210px]"
            } font-ar cursor-pointer`}
          >
            {t("forms.component.skipToWebsite")}
          </div>
        </Link>
        <div className="flex flex-col w-[347px] tablet:w-[310px] mobile:w-[274px] items-start">
          <Formik
            initialValues={initialValues}
            onSubmit={() => formik.submitForm()}
          >
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              {openForm === 1 && (
                <div className="flex flex-col">
                  <div className="mt-[109px] mb-16 mobile:mt-8 mobile:mb-8 mobile:mr-[-18px] text-zinc500 text-start text-base mobile:text-sm font-ar">
                    {t("forms.component.ThroughYourAnswers")}
                  </div>
                  <label className="text-lg text-zinc600 pb-6 font-arBold">
                    {t("forms.component.areaYouliveIn")}
                  </label>
                  <div className="flex flex-col w-full gap-6">
                    <Select
                      label={t("forms.component.country")}
                      options={
                        i18n.language === "ar" ? list.country : list.countryEn
                      }
                      onChange={(e) => formik.handleChange(e)}
                      name="country"
                    />
                    <Select
                      label={t("forms.component.city")}
                      options={i18n.language === "ar" ? list.city : list.cityEn}
                      onChange={(e) => formik.handleChange(e)}
                      name="city"
                    />
                    <Select
                      label={t("forms.component.district")}
                      options={
                        i18n.language === "ar" ? list.district : list.districtEn
                      }
                      onChange={(e) => formik.handleChange(e)}
                      name="district"
                    />
                  </div>
                  <button
                    className="w-[345px] h-[67px] tablet:w-[310px] mobile:w-[274px] mt-11 px-8 py-2 border rounded-xl bg-navey500 text-zinc50 text-xl font-arMedium"
                    onClick={() => handleNextAndPreviousForms("next")}
                  >
                    {t("forms.component.next")}
                  </button>
                  <div className="flex flex-col items-center mt-6 mobile:mt-[93px]">
                    <div className="w-[120px] bg-zinc200 rounded-full h-1.5">
                      <div className="bg-tart500 h-1.5 rounded-full w-[30%]"></div>
                    </div>
                  </div>
                </div>
              )}
              {openForm === 2 && (
                <div className="flex flex-col">
                  <div className="mt-10 mb-16 mobile:mt-8 mobile:mb-8 mobile:mr-[-18px] text-zinc500 text-start text-base mobile:text-sm font-ar">
                    {t("forms.component.ThroughYourAnswers")}
                  </div>
                  <label className="text-lg text-zinc600 pb-6 font-arBold">
                    {t("forms.component.aboutTheClass")}
                  </label>
                  <div className="flex flex-col w-full gap-4">
                    <Select
                      label={t("forms.component.numberofstudent")}
                      options={
                        i18n.language === "ar"
                          ? list.numberofstudent
                          : list.numberofstudentEn
                      }
                      name="numberofstudent"
                      onChange={(e) => formik.handleChange(e)}
                    />
                    <Select
                      label={t("forms.component.budgetandfees")}
                      options={
                        i18n.language === "ar"
                          ? list.budgetandfees
                          : list.budgetandfeesEn
                      }
                      name="budgetandfees"
                      onChange={(e) => formik.handleChange(e)}
                    />
                    <Select
                      label={t("forms.component.edusystem")}
                      options={
                        i18n.language === "ar"
                          ? list.edusystem
                          : list.edusystemEn
                      }
                      name="edusystem"
                      onChange={(e) => formik.handleChange(e)}
                    />
                  </div>
                  <div className="flex gap-2 pt-1 items-center">
                    <input type="checkbox" name="providingbuses"></input>
                    <label className="text-lg font-arBold text-zinc600">
                      {t("forms.component.providingbuses")}
                    </label>
                  </div>
                  <div className="flex  flex-col gap-4">
                    <button
                      className="w-[345px] h-[67px] tablet:w-[310px] mobile:w-[274px] mt-3.5 px-8 py-2 border rounded-xl bg-navey500 text-zinc50 text-xl font-arMedium"
                      onClick={() => handleNextAndPreviousForms("next")}
                    >
                      {t("forms.component.next")}
                    </button>
                    <button
                      className="w-[345px] h-[67px] tablet:w-[310px] mobile:w-[274px] px-4 py-2 border-2 border-slate-700 rounded-xl text-navey-700 text-xl font-arMedium"
                      onClick={() => handleNextAndPreviousForms("prev")}
                    >
                      {t("forms.component.previous")}
                    </button>
                  </div>
                  <div className="flex flex-col items-center mt-6">
                    <div className="w-[120px] bg-zinc200 rounded-full h-1.5">
                      <div className="bg-tart500 h-1.5 rounded-full w-[55%]"></div>
                    </div>
                  </div>
                </div>
              )}
              {openForm === 3 && (
                <div className="flex flex-col">
                  <div className="mt-10 mb-16 mobile:mt-8 mobile:mb-8 mobile:mr-[-18px] text-zinc500 text-start text-base mobile:text-sm font-ar">
                    {t("forms.component.ThroughYourAnswers")}
                  </div>
                  <label className="text-lg text-zinc600 pb-6 font-arBold">
                    {t("forms.component.aboutTheClass")}
                  </label>
                  <div className="flex flex-col w-full gap-6">
                    <Select
                      label={t("forms.component.educationevel")}
                      options={
                        i18n.language === "ar"
                          ? list.educationLevel
                          : list.educationLevelEn
                      }
                      name="educationevel"
                      onChange={(e) => formik.handleChange(e)}
                    />
                    <Select
                      label={t("forms.component.ExtracurricularActivities")}
                      options={
                        i18n.language === "ar"
                          ? list.ExtracurricularActivities
                          : list.ExtracurricularActivitiesEn
                      }
                      name="ExtracurricularActivities"
                      onChange={(e) => formik.handleChange(e)}
                    />
                    <Select
                      label={t("forms.component.SportsActivities")}
                      options={
                        i18n.language === "ar"
                          ? list.SportsActivities
                          : list.SportsActivitiesEn
                      }
                      name="SportsActivities"
                      onChange={(e) => formik.handleChange(e)}
                    />
                  </div>
                  <div className="flex  flex-col gap-4">
                    <Link to={appRoutesObj.getResearchResultsPath()}>
                      <button
                        type="submit"
                        className="w-[345px] h-[67px] tablet:w-[310px] mobile:w-[274px] mt-[30px] px-8 py-2 border rounded-xl bg-navey500 text-zinc50 text-xl font-arMedium"
                      >
                        {t("forms.component.search")}
                      </button>
                    </Link>
                    <button
                      className="w-[345px] h-[67px] tablet:w-[310px] mobile:w-[274px] px-4 py-2 border-2 border-slate-700 rounded-xl text-navey-700 text-xl font-arMedium"
                      onClick={() => handleNextAndPreviousForms("prev")}
                    >
                      {t("forms.component.previous")}
                    </button>
                  </div>
                  <div className="flex flex-col items-center mt-6">
                    <div className="w-[120px] bg-zinc200 rounded-full h-1.5">
                      <div className="bg-tart500 h-1.5 rounded-full w-[100%]"></div>
                    </div>
                  </div>
                </div>
              )}
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default QuestionForms;
